import React from 'react';

import { DetalhamentoCreditoDetailComp, DetalhamentoCreditoListComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function DetalhamentoCreditoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_DETALHAMENTO_CREDITO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <DetalhamentoCreditoListComp />
        </ListagemProvider>
    );
}

export function DetalhamentoCreditoDetail() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_DETALHAMENTO_CREDITO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <DetalhamentoCreditoDetailComp />
        </ListagemProvider>
    );
}
